import jspb from 'google-protobuf';
import moment from 'moment';
import moment_tz from 'moment-timezone';

//var moment = require('moment-timezone');

export default class WebSocketEx extends WebSocket
{
//public sName : string | null = null;

public bClosedCalled : boolean = false;

constructor(sUrl : string)
{
super(sUrl);
}

};